// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___3jfn2","StripeElement":"StripeElement___13nW4"};